import Main from './Main'

export interface IOptions {
  width?: number
  height?: number
  title?: string
  xAxisLabel?: string
  yAxisLabel?: string
  dataset1Label?: string
  dataset2Label?: string
  dataset1Color?: string
  dataset2Color?: string
}

interface IProps {
  xAxisData: any[]
  dataset1Data: number[]
  dataset2Data: number[]
  options?: IOptions
}

function ComparisonBarChart({
  xAxisData,
  dataset1Data,
  dataset2Data,
  options = {},
}: IProps) {
  return (
    <Main
      xAxisData={xAxisData}
      dataset1Data={dataset1Data}
      dataset2Data={dataset2Data}
      options={options}
    />
  )
}

export default ComparisonBarChart
